import { IPaybPayment } from '@global/types/types';

import { useTranslation } from 'react-i18next';
interface PaymentInfoProps {
  paymentInfo: IPaybPayment | null;
}

export const Payment = ({ paymentInfo }: PaymentInfoProps) => {
  const { t } = useTranslation();
  const cartLastFourNumbers = paymentInfo?.ccpaCardNumber.toString().slice(-4);
  return (
    <span>
      {`${t('confirmation.details.cardEnding')} ${cartLastFourNumbers}`}
    </span>
  );
};
